import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-surface py-12 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-90" data-mp="4vs0dxwxedqv">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-91" data-mp="9t1mb3l3w79y">
        <Medallion icon={ShieldCheckIcon} data-id="element-92" data-mp="etpngi31u4hw" />

        <p className="mt-6 font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-accent" data-id="element-93" data-mp="euqwyi4f2ixi">Garanzia di 7 giorni</p>
        <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-serif text-[2.2rem] font-bold leading-[1.05] text-ink sm:text-[2.6rem]" data-id="element-94" data-mp="nu4ablvnvrni">
          100% protetto
        </h2>

        <p className="mx-auto mt-6 max-w-prose font-sans text-base leading-relaxed text-muted" data-id="element-95" data-mp="sn6w37u75wt5">
          Accedi al sistema completo e verifica di aver ricevuto i 6 volumi e i
          5 bonus dettagliati in questa pagina.
        </p>
        <p className="mx-auto mt-4 max-w-prose font-sans text-base leading-relaxed text-muted" data-id="element-96" data-mp="17hlep79un47a">
          Se qualche file è incompleto, presenta problemi di accesso o il
          contenuto non corrisponde alla descrizione di questa offerta,
          scrivici entro 7 giorni. Lo controlleremo e, se non riusciamo a
          risolvere il problema, ti rimborseremo il{' '}
          <span className="font-semibold text-ink" data-id="element-97" data-mp="1rs5q084ckne4">100% del tuo acquisto</span>.
        </p>
        <p className="mt-6 font-serif text-2xl font-bold leading-snug text-accent" data-id="element-98" data-mp="1ruigxas3283b">
          Rischio zero per te.
        </p>
      </div>
    </section>;
}